(function ($, UX) {
    let $window = $(window);

    UX.article = UX.article || {};
    UX.settings = UX.settings || {};
    UX.settings.article = UX.settings.article || {};

    // default settings
    UX.settings.article = $.extend(
        true,
        {},
        {
            selector: {
                toc__block: '.tos-list__body',
                toc__nav: '[data-create=tos]',
                toc__targets:
                    '.article__content .section__title, .authorArticleInfoCon, .table-of-content .tos-list__target',
                article__content: '.article__content, .table-of-content',
            },
        },
        UX.settings.article
    );

    UX.article.init = function () {
        UX.article.toc__create();
        $window.on('scroll', UX.article.toc__scrollSpy);
    };

    /// Document TOC creator
    UX.article.toc__create = function () {
        var $sections = (UX.article.$sections = $(UX.settings.article.selector.toc__targets));
        var $nav = (UX.article.$nav = $(UX.settings.article.selector.toc__nav));
        var $block = (UX.article.$ctrl = $(UX.settings.article.selector.toc__block));
        var $articleContent = (UX.article.$articleContent = $(UX.settings.article.selector.article__content));
        UX.article.offset =
            ($('.header').outerHeight() || 0) +
            ($('.navbar').outerHeight() || 0) +
            ($('.article__navbar').outerHeight() || 0);

        if (!$nav.length || !($sections.length > 1)) {
            $nav.remove();
            $block.remove();
            return;
        }

        $articleContent.addClass('has-sections');

        const ul = $('<ul class="rlist w-slide--list" role="menu"/>').appendTo($nav);
        $sections.each(function () {
            const $this = $(this).clone(),
                $li = $('<li/>').attr('role', 'menuitem').appendTo(ul),
                $link = $('<a class="w-slide__hide"/>')
                    .attr('href', '#' + $this.attr('id'))
                    .appendTo($li);
            $this.find('.ref').remove();
            $('<span/>').text($this.text()).appendTo($link);
        });
    };

    UX.article.toc__scrollSpy = _.debounce(function () { /*eslint-disable-line*/
        let id;
        // @todo: taken code from 'side-bar-sections' - should be refactored to not use EACH
        UX.article.$sections.each(function (e) {
            if ($(window).scrollTop() >= $(this).offset().top - UX.article.offset - $(this).outerHeight() - 15) {
                id = $(this).attr('id');
                UX.article.$nav.find('a').removeClass('active');
                UX.article.$nav.find('a[href="#' + id + '"]').addClass('active');
            }
        });
    });

    // init self on ready
    $(document).ready(UX.article.init);
})(jQuery, UX);
